._IIcon_5jkr5_1 {
  display: inline;
  height: 1em;
  vertical-align: middle;
  width: 1em;
}
